// Libs
import React, { useContext, useEffect, useState } from 'react';
import * as Yup from 'yup';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { Demanda } from '@app/api/demanda';

//Files
import { Visibility } from '@app/components/Visibility';
import ModalFinalizarEtapaDados from '../ModalFinalizarEtapaDados';

//Utils
import {optionsSwitch} from '@app/helpers/optionsSwitch';
import QuestionarioContextProvider from '@app/hooks/useQuestionario';
import { EStatusDemanda } from '@app/enums/EStatusDemanda';

interface StepDadosRequisicaoProps {
    disabled?: boolean;
}

function StepDadosRequisicao({
    disabled = false,
}: StepDadosRequisicaoProps) {
    const { demandaData, isAdmContrato } = useContext(QuestionarioContextProvider);

    const [demandaDataForm, setDemandaDataForm] = useState({} as Demanda);

    useEffect(() => {
        if (demandaData) {
            setDemandaDataForm(demandaData);
        }
    }, [demandaData])

    return (
        <>
            {demandaData
                && demandaData.statusCodigo === EStatusDemanda.AguardandoPreenchimentoDemandante
                && <ModalFinalizarEtapaDados />}
            <ui.Row>
                <ui.FormSelect
                    options={optionsSwitch}
                    label="Demanda é emergencial?"
                    name="isEmergencial"
                    id='mrn-select-isEmergencial'
                    span={4}
                    required
                    onSelect={value => {
                        let dem = { ...demandaDataForm, isEmergencial: value as any } as Demanda;
                        setDemandaDataForm(dem);
                    }}
                    disabled={disabled}
                />

                <ui.FormSelect
                    label="Fornecedor Direcionado?"
                    name="isFornecedorDirecionado"
                    id='mrn-select-isFornecedorDirecionado'
                    options={optionsSwitch}
                    span={4}
                    required
                    onSelect={value => {
                        let dem = { ...demandaDataForm, isFornecedorDirecionado: value as any } as Demanda;
                        setDemandaDataForm(dem);
                    }}
                    disabled={disabled}
                />
            </ui.Row>

            <Visibility visible={demandaDataForm && demandaDataForm.isFornecedorDirecionado}>
                <ui.Row>
                    <ui.FormInput
                        label="Justificativa Fornecedor Direcionado"
                        name="justificativaFornecedorDirecionado"
                        id='mrn-input-justificativaFornecedorDirecionado'
                        span={6}
                        required
                        disabled={disabled}
                        validateSchema={Yup.string()
                            .trim()
                            .max(2000, 'A Justificativa deve ter no máximo 2000 caracteres.')}
                    />
                </ui.Row>
            </Visibility>

            <Visibility
                visible={demandaDataForm && demandaDataForm.isEmergencial}
            >
                <ui.Row style={{ paddingBottom: '10px', paddingLeft: '10px', paddingTop: '10px' }}>
                    Demandas emergenciais são àquelas que se encaixam em pelo menos uma das condições abaixo relacionadas,
                    devendo ser aprovadas seguindo as alçadas de aprovação previstas na NS 1/003
                </ui.Row>
                <ui.Row>
                    <ui.FormInput
                        label="Justificativa Emergência"
                        name="justificativaEmergencia"
                        id='mrn-input-justificativaEmergencia'
                        validateSchema={Yup.string()
                            .trim()
                            .required('Campo requerido.')
                            .min(40, 'A Justificativa deve ter no mínimo 40 caracteres.')
                            .max(2000, 'A Justificativa deve ter no máximo 2000 caracteres.')}
                        disabled={disabled}
                    />
                </ui.Row>
                <ui.Row>
                    <ui.Col span={6}>
                        <ui.FormCheckbox
                            className="form-wrapper"
                            name="caracteristicaEmergencia"
                            id='mrn-checkbox-caracteristicaEmergencia'
                            label="Características de Emergência:"
                            required
                            options={[
                                {
                                    text: 'Parada ou redução de produção imediata',
                                    value: 'paradaOuReducaoProducaoImediata',
                                },
                                {
                                    text: 'Comprometimento da imagem MRN',
                                    value: 'comprometimentoImagemMrn',
                                },
                                {
                                    text: 'Perdas financeiras',
                                    value: 'perdasFinanceiras',
                                },
                                {
                                    text: 'Riscos iminentes do Meio Ambiente',
                                    value: 'riscosIminentesMeioAmbiente',
                                },
                                {
                                    text: 'Riscos à saúde e segurança no trabalho',
                                    value: 'riscosSaudeSegurancaTrabalho',
                                },
                            ]}
                            disabled={disabled}
                        />
                    </ui.Col>
                </ui.Row>
            </Visibility>
        </>
    )
}

export default StepDadosRequisicao